import React from 'react';
import cx from 'classnames';
import { ELSIconV2 } from 'components/common';
import { onKeyDownHandler } from 'helpers/ui.helper';
import { SORT_DIRECTION, SORT_DIRECTION_ARIA_LABEL } from 'constants/app.constant';
var HeaderCell = function (_a) {
    var column = _a.column, idx = _a.idx, sortField = _a.sortField, sortDirection = _a.sortDirection, hasScrollLeft = _a.hasScrollLeft, onHeaderClick = _a.onHeaderClick, headerIconPosition = _a.headerIconPosition, tableId = _a.tableId;
    var alignClass = column.align ? "u-els-text-align-".concat(column.align) : '';
    var isSortActive = column.field === sortField;
    var thId = "".concat(tableId !== null && tableId !== void 0 ? tableId : 'tbl', "-col-").concat(String(column.field));
    var isAsc = sortDirection === SORT_DIRECTION.ASC;
    var currentSortDirection = isAsc ? SORT_DIRECTION_ARIA_LABEL.asc : SORT_DIRECTION_ARIA_LABEL.desc;
    var nextSortDirection = isAsc ? SORT_DIRECTION_ARIA_LABEL.desc : SORT_DIRECTION_ARIA_LABEL.asc;
    var ariaSortValue;
    if (isSortActive) {
        ariaSortValue = currentSortDirection;
    }
    else if (column.field) {
        ariaSortValue = 'none';
    }
    return (<th id={thId} scope="col" aria-sort={ariaSortValue} className={cx('c-els-table__cell c-els-table__cell--header', {
            'c-responsive-table-cell--sort-active': isSortActive,
            'c-responsive-table-body-cell--sticky': !idx,
            'c-responsive-table-body-cell--right-shadow': !idx && hasScrollLeft
        }, column.headerCssModifier, alignClass)}>
      {column.customHeaderRender ? (<div className={alignClass}>{column.customHeaderRender({ onClick: function () { return onHeaderClick(column.field); }, sortDirection: sortDirection, isSortActive: isSortActive })}</div>) : (<>
          {column.customFirstHeaderRender && <div>{column.customFirstHeaderRender()}</div>}
          <button type="button" aria-label={isSortActive
                ? "".concat(String(column.header), ", sorted ").concat(currentSortDirection, ", activate to sort ").concat(nextSortDirection)
                : "".concat(String(column.header), ", activate to sort ").concat(SORT_DIRECTION_ARIA_LABEL.asc)} className={cx(alignClass, 'c-els-table__sortable-button', column.headerCssModifier)} onClick={function () { return onHeaderClick(column.field); }} onKeyDown={function (evt) { return onKeyDownHandler(evt, function () { return onHeaderClick(column.field); }); }}>
            <span className="c-responsive-table__sort-button-text">{column.header}</span>
            {isSortActive && (<ELSIconV2 sprite={isAsc ? 'ArrowUp' : 'ArrowDown'} size="xs" aria-hidden textAlignment={headerIconPosition || 'top'} className={cx('u-els-margin-left-1o4', { 'c-responsive-table-cell--sort-asc': isAsc })}/>)}
            {column.headerPendoClass && (<ELSIconV2 sprite="InformationOutlineCircle" size="xs" aria-hidden textAlignment="offset" className={"u-cursor-pointer u-els-color-secondary u-els-margin-left-1o2 js-pendo-".concat(column.headerPendoClass)}/>)}
          </button>
        </>)}
    </th>);
};
export default HeaderCell;
